import { useCMSPageField } from '@/cms/fields'
import { CMSMediaType } from '@/cms/fields/mappers/productDetailPageFieldsMapper'
import { useIntl } from '@/intl'
import { FullScreenGallery } from '@/scopes/common/components/FullScreenGallery'
import { ImageCarousel } from '@/scopes/common/components/ImageCarousel'
import Map from '@/scopes/destinations/components/DestinationInformation/Map/Map'
import SectionTitle from '@/scopes/destinations/components/SectionTitle'
import { Button, RichText, Sheet, useBreakpoints } from '@sunwebgroup/ui-components/uds'
import { startTransition, useMemo, useState } from 'react'

import styles from './DestinationInformation.module.css'

export default function DestinationInformation() {
  const intl = useIntl()
  const destinationMap = useCMSPageField('DestinationPage.map')
  const destinationImages = useCMSPageField('DestinationPage.images')
  const productName = useCMSPageField('DestinationPage.productName')
  const description = useCMSPageField('DestinationPage.destinationDescription')
  const [showGallery, setShowGallery] = useState(false)
  const [activeSlide, setActiveSlide] = useState(0)
  const [isSheetOpen, setSheetOpen] = useState(false)
  const { isTabletOrGreater } = useBreakpoints()

  const images = useMemo(() => destinationImages?.map((src, idx) => ({
    src,
    alt: `${productName} ${intl.formatMessage({ id: 'photo_gallery_full_photo_gallery_title' }, { currentImage: idx + 1, totalImages: destinationImages.length })}`,
    type: CMSMediaType.IMAGE,
    aspectRatio: '3:2',
  })), [destinationImages, productName])

  const aboutTitle = intl.formatMessage({ id: 'destination_title_about' }, { destinationName: productName })

  return (
    <div className={styles.destinationInformation}>
      {description && (
        <section className={styles.description}>
          {productName && (
            <SectionTitle>
              {aboutTitle}
            </SectionTitle>
          )}
          <div className={styles.textTruncate}>
            <RichText innerHTML={description} />
          </div>
          <Sheet.Root open={isSheetOpen} onOpenChange={() => setSheetOpen(!isSheetOpen)}>
            <Sheet.Trigger>
              <Button size="M" variant="transparentPrimary">
                {intl.formatMessage({ id: 'description_read_more' })}
              </Button>
            </Sheet.Trigger>
            <Sheet.Body side={isTabletOrGreater ? 'right' : 'bottom'}>
              <Sheet.Header
                closeLabel={intl.formatMessage({ id: 'close' })}
                titleLabel={aboutTitle}
              />
              <Sheet.Content>
                <RichText innerHTML={description} />
              </Sheet.Content>
            </Sheet.Body>
          </Sheet.Root>
        </section>
      )}
      <div className={styles.mediaColumn}>
        {destinationMap && <Map />}
        {!destinationMap && images && (
          <>
            <div className={styles.imageWrapper}>
              <ImageCarousel
                onClick={(slide) => {
                  setActiveSlide(slide)
                  startTransition(() => {
                    setShowGallery(true)
                  })
                }}
                images={images}
              />
            </div>
            {showGallery && (
              <FullScreenGallery
                onClose={() => setShowGallery(false)}
                startFromIndex={activeSlide}
                open={showGallery}
                media={images}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}
